import React from "react";

const Note = ({ children }) => {
  return (
    <div
      style={{
        backgroundColor: "#F1FAFE",
        color: "#032954",
        borderRadius: "4px",
        width: "100%",
        padding: "8px",
        marginTop: "14px",
      }}
    >
      <p style={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>
        {children}
      </p>
    </div>
  );
};
export default Note;
